import { render, staticRenderFns } from "./TableHeaderCellV2.vue?vue&type=template&id=791f4585&scoped=true&"
import script from "./TableHeaderCellV2.vue?vue&type=script&lang=js&"
export * from "./TableHeaderCellV2.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderCellV2.vue?vue&type=style&index=0&id=791f4585&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791f4585",
  null
  
)

export default component.exports